import { apiRequest } from './httpClient';
import { CONSTRUCTION_API_BASE, POSTS_API_BASE } from './apiConfig';
import { junctionBoxYnForApi } from '../utils/postForm';

const API_BASE = POSTS_API_BASE;
const toQueryString = (params) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value);
    }
  });
  return searchParams.toString();
};

export const createPost = async (payload) => {
  await apiRequest(`${API_BASE}/create`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const fetchPostList = async (params) => {
  const queryString = toQueryString(params);
  const url = queryString ? `${API_BASE}?${queryString}` : API_BASE;
  return apiRequest(url);
};

export const fetchPostById = async (id) => apiRequest(`${API_BASE}/${id}`);

export const updatePost = async (id, payload) => {
  await apiRequest(`${API_BASE}/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
};

export const deletePost = async (id) => {
  await apiRequest(`${API_BASE}/${id}`, {
    method: 'DELETE',
  });
};

export const uploadConstructionList = async (payload) => {
  return apiRequest(`${CONSTRUCTION_API_BASE}/bulk`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const createConstruction = async (payload) => {
  await apiRequest(CONSTRUCTION_API_BASE, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const fetchConstructionList = async (params) => {
  const queryString = toQueryString(params ?? {});
  const url = queryString ? `${CONSTRUCTION_API_BASE}?${queryString}` : CONSTRUCTION_API_BASE;
  return apiRequest(url);
};

/** 페이지를 순회하며 시공 목록 전체를 조회합니다. */
export const fetchAllConstructionList = async (params = {}) => {
  const { possessor, sort = 'id,desc' } = params;
  const pageSize = 100;
  let page = 0;
  let totalPages = 1;
  const allContent = [];

  do {
    const result = await fetchConstructionList({
      possessor,
      page,
      size: pageSize,
      sort,
    });
    const content = Array.isArray(result?.content) ? result.content : [];
    allContent.push(...content);
    totalPages = Math.max(result?.totalPages ?? 1, 1);
    page += 1;
  } while (page < totalPages);

  return allContent;
};

export const fetchConstructionById = async (id) => apiRequest(`${CONSTRUCTION_API_BASE}/${id}`);

export const updateConstruction = async (id, payload) => {
  await apiRequest(`${CONSTRUCTION_API_BASE}/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
};

const optionalInt = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const n = parseInt(String(value).replace(/,/g, '').trim(), 10);
  return Number.isFinite(n) ? n : null;
};

const optionalDouble = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const n = parseFloat(String(value).replace(/,/g, '').trim());
  return Number.isFinite(n) ? n : null;
};

/** 시공정보 작성/수정 폼 → API JSON (숫자 필드 타입 맞춤) */
export const buildConstructionApiPayload = (form) => {
  const noteTrimmed = form.note == null ? '' : String(form.note).trim();
  return {
    ...form,
    moduleQuantity: optionalInt(form.moduleQuantity),
    inverterQuantity: optionalInt(form.inverterQuantity),
    ratedVoltage: optionalInt(form.ratedVoltage),
    capacity: optionalDouble(form.capacity),
    inverterCapacity: optionalDouble(form.inverterCapacity),
    junctionBoxYn: junctionBoxYnForApi(form.junctionBoxYn),
    note: noteTrimmed === '' ? null : noteTrimmed,
  };
};
